import { useEffect, useRef, useState } from "react";
import { FaBoxOpen } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { getAllProductsLoder } from "../../features/products/productsSlice";
import { getAllWishlist } from "../../features/wishlist/wishlistSlice";
import Loader_Lottie from "../animation/Loader_Lottie/Loader_Lottie";
import Product_filter from "./product-filter/Product_filter";
import Search_products from "./search-products/Search_products";
import Frames_card from "../common-components/common-card/frame-card/Frames_card";
import Pagination_Holder from "../common-components/pagination_holder/Pagination_Holder";
import "./All_products.css";
import { getAllPriceRange } from "../../features/master/masterSlice";
import VirtualTryOn from "../virtual-try-on/Virtual_try_on";
import { get3DImage } from "../../utils/common";

// Keys in `filters` that hold arrays of { id, name }, and the label shown on each chip
const FILTER_LABELS = {
  category: "Category",
  gender: "Gender",
  material: "Material",
  frameType: "Frame Type",
  colour: "Colour",
  brands: "Brand",
  frameShape: "Shape",
  modality: "Modality",
  vision: "Vision",     // new
  product: "Product", 
};

const PAGE_STORE = "all_products_page";

const All_products = ({
  handleFilterReset,
  filters,
  handleFilterChange,
  handleSearchCategorySelect,
  handleSearchProductSelect, // replaces all filters when a suggestion is picked
  setPrice,
  price,
}) => {
  const dispatch = useDispatch();

  const topframes = useSelector((state) => state.product.allProductsLoder);

  const filtersString = JSON.stringify(filters);
  const priceString = JSON.stringify(price);
  const filterKey = `${filtersString}|${priceString}`;


  const [onPageChange, setOnPageChange] = useState(() => {
    try {
      const saved = JSON.parse(sessionStorage.getItem(PAGE_STORE) || "null");
      if (saved && saved.key === filterKey && Number(saved.page) > 0) return Number(saved.page);
    } catch (e) {

    }
    return 1;
  });
  const [totalPages, setTotalPages] = useState(1);
  const [loder, setLoder] = useState(false);
  const [showTryOn, setShowTryOn] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const priceRange = useSelector((state) => state.master.price_range);
  const is_signin = useSelector((state) => state.auth.is_signin);

  const gridRef = useRef(null);
  const lastKey = useRef(filterKey); 
  const firstScroll = useRef(true);

  const isSearchActive = Boolean(filters?.productId || filters?.name);

  // Flat list of everything currently selected in the filter -> shown as chips
  const selectedChips = Object.keys(FILTER_LABELS).flatMap((key) =>
    (Array.isArray(filters?.[key]) ? filters[key] : []).map((item) => ({
      key,
      id: item?.id,
      name: item?.name,
    })),
  );

  // Chips are NOT shown when the products came from the search box
  const showChips = !isSearchActive && selectedChips.length > 0;

  // The filter's onFilterChange toggles an item, so calling it again removes it
  const handleRemoveChip = (chip) => {
    handleFilterChange(chip.key, { id: chip.id, name: chip.name });

    if (filters?.productId) {
      handleFilterChange("productId", "");
      handleFilterChange("name", "");
    }
  };


  const handleSidebarFilterChange = (key, value) => {
    if (filters?.productId || filters?.name) {
      handleFilterChange("productId", "");
      handleFilterChange("name", "");
    }
    handleFilterChange(key, value);
  };

  // Scroll to the top when the page changes (the page and the product list both)
  useEffect(() => {
    if (firstScroll.current) {
      firstScroll.current = false;
      window.scrollTo({ top: 0 });
      return;
    }
    if (gridRef.current) gridRef.current.scrollTop = 0;
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [onPageChange]);

  // Get products. Different filters always start again at page 1.
  useEffect(() => {
    if (lastKey.current !== filterKey && onPageChange !== 1) {
      lastKey.current = filterKey;
      setOnPageChange(1);
      return;
    }
    lastKey.current = filterKey;

    try {
      sessionStorage.setItem(PAGE_STORE, JSON.stringify({ key: filterKey, page: onPageChange }));
    } catch (e) {
      
    }

    dispatch(
      getAllProductsLoder({
        filters,
        page: onPageChange,
        price,
        setLoder,
      }),
    );
    // eslint-disable-next-line
  }, [filterKey, onPageChange, dispatch]);

  // Set pagination data
  useEffect(() => {
    if (topframes && topframes.data) {
      const total = Math.max(1, Number(topframes.total_pages) || 1);
      setTotalPages(total);
      
      if (onPageChange > total) setOnPageChange(total);
    }
    // eslint-disable-next-line
  }, [topframes]);

  // Wishlist
  useEffect(() => {
    if (is_signin) {
      dispatch(getAllWishlist());
    }
  }, [dispatch, is_signin]);

  // Price range
  useEffect(() => {
    dispatch(getAllPriceRange());
  }, [dispatch]);

  // Reset the search keyword when leaving this page (e.g. navigating to a
  // product detail page), so clicking Back shows the full product list
  // again instead of the last single-product search result.
  useEffect(() => {
    return () => {
      handleFilterChange("name", "");
      handleFilterChange("productId", "");
    };
  }, []);

  const handlePageChange = (pageNumber) => {
    const n = Number(pageNumber);
    if (!Number.isFinite(n)) return;
    setOnPageChange(Math.min(Math.max(1, n), totalPages));
  };

  const vtoImage = get3DImage(selectedProduct?.Product_Images) || "";

  return (
    <>
      <section className="all_products_sec">
        <div className="container-fluid">
          <div className="row">
            {/*
              FILTER - visible on the left on desktop (lg and up).
              On tablet / mobile it stays hidden (CSS) but is still mounted,
              so its logic keeps running.
            */}
            <div className="filtersec col-lg-3 col-xl-2 d-none d-lg-block mt-2">
              <Product_filter
              filters={filters}
  onFilterChange={handleSidebarFilterChange}
  setPrice={setPrice}
  price={price}
  handleFilterReset={handleFilterReset}
              />
            </div>

            {/* PRODUCTS */}
            <div className="col-12 col-lg-9 col-xl-10 mt-2">
              <div className="rightsec">
                {/* SELECTED FILTERS (above the search bar) - hidden while a
                    product / keyword search is active */}
                {showChips && (
                  <div className="selected_filters">
                    {selectedChips.map((chip) => (
                      <span
                        className="filter_chip"
                        key={`${chip.key}-${chip.id}`}
                      >
                        <span className="filter_chip_label">
                          {FILTER_LABELS[chip.key]}:
                        </span>
                        <span className="filter_chip_name">{chip.name}</span>
                        <button
                          type="button"
                          className="filter_chip_remove"
                          aria-label={`Remove ${chip.name}`}
                          onClick={() => handleRemoveChip(chip)}
                        >
                          &times;
                        </button>
                      </span>
                    ))}

                    {handleFilterReset && (
                      <button
                        type="button"
                        className="filter_clear_all"
                        onClick={handleFilterReset}
                      >
                        Clear all
                      </button>
                    )}
                  </div>
                )}

                <Search_products
                  filters={filters}
                  onFilterChange={handleFilterChange}
                  onCategorySelect={handleSearchCategorySelect}
                  onProductSelect={handleSearchProductSelect}
                />

                {/* PRODUCTS */}
                <div className="cards_sec_holder" ref={gridRef}>
                  <div className="products_grid">
                    {topframes?.data && topframes.data.length > 0 ? (
                      topframes.data.map((data) => (
                        <div key={data?.id} className="product_cell">
                          <Frames_card
                            image={data?.image}
                            id={data?.id}
                            name={data?.name}
                            prise={data?.price}
                            oldprise={data?.mrp}
                            vto_enable={data?.vto_enable}
                            setSelectedProduct={() => {
                              setShowTryOn(true);
                              setSelectedProduct(data);
                            }}
                          />
                        </div>
                      ))
                    ) : loder ? (
                      <div className="grid_full text-center p-5">
                        <Loader_Lottie />
                        <h5 className="mt-3 text-muted">
                          Loading products, please wait…
                        </h5>
                      </div>
                    ) : (
                      <div className="grid_full text-center p-5">
                        <FaBoxOpen size={50} color="#b0b0b0" />
                        <h5 className="mt-3 text-muted">
                          No products available
                        </h5>
                      </div>
                    )}
                  </div>
                </div>

                {/* PAGINATION */}
                {totalPages > 1 && (
                  <div className="comon_page_footer">
                    <div className="pagination_div">
                      <Pagination_Holder
                        onPageChange={onPageChange}
                        totalPages={totalPages}
                        handlePageChange={handlePageChange}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          <VirtualTryOn
            isOpen={showTryOn}
            onClose={() => setShowTryOn(false)}
            category={selectedProduct?.p_category}
            brand={selectedProduct?.Brand}
            size={selectedProduct?.size}
            total_measurements={selectedProduct?.total_measurements}
            productImages={selectedProduct?.Product_Images}
            glbModal={vtoImage}
            is3DVTO={selectedProduct?.is_3D_VTO}
          />
        </div>
      </section>
    </>
  );
};

export default All_products;